import React from "react";

const BS5_StackedHorizontal = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_StackedHorizontal Component</h2>
      <p>This is the BS5_StackedHorizontal component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_StackedHorizontal;
